module.exports = __webpack_public_path__ + "static/media/bike2c.afec2d2d.jpg";